// --------------------------------------------------------
// AGENDA PROFISSIONAL LIST ITEM - AgendaProfissionalListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Table, Avatar } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Colors from '../../constants/Colors'
import { Paths } from '../../enums/Paths'
import { getDescricaoByCodigo } from '../../enums/Roles'
import useFetchPhoto from '../../hooks/useFetchPhoto'
import useNavigationHelper from '../../hooks/useNavigationHelper'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { RowContainer } from '../../pages/careLine/CareLine.styled'
import { MobileContainer } from '../companyListItem/CompanyListItemMobile.styled'
import { GenericSolidButton } from '../UI/buttons/Button.styled'
import { ListItemContainer, TableData, Text, TextLink } from '../UI/generalLayout/Layout.styled'
import { ActivityStatus } from './AgendaProfissionalListItem.styled'
import avatar from '../../assets/imgs/avatar.jpg';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// AGENDA PROFISSIONAL LIST ITEM INTERFACE
// --------------------------------------------------------

interface IAgendaProfissionalListItem {
    item: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AgendaProfissionalListItem = ({ item }: IAgendaProfissionalListItem) => {
    // --------------------------------------------------------
    // AGENDA PROFISSIONAL LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const navigate = useNavigate()
    const  { isMobile } = useResponsiveInfo();
    const { navigateToHealthProfessionalDetail } = useNavigationHelper()
    const [photo, setPhoto] = useState<any>(null);

    const navigateToHealthProfessionalDetailInner = ()=>{
        return navigateToHealthProfessionalDetail(item)
    }

    const navigateToCreateAgendaInner = ()=>{
        return navigate(Paths.CriarAgenda, { state: {nomeProfissional: item.nome, agenda: item}})
    }
    
    useFetchPhoto(item.foto, setPhoto);

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ListItemContainer>
                {!isMobile? (<Table>
                    <TableData width={'2%'} style={{verticalAlign: 'middle'}}>
                        <Avatar color={Colors.SPM500} src={item.foto ? photo : avatar} /> {/** Avatar aqui caso não tenha foto */}
                    </TableData>
                    <TableData width={'18%'} style={{verticalAlign: 'middle'}}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <div>
                                <Text style={{ fontSize: 14 }}>{item.nome}</Text>
                                <div style={{ marginTop: -10, flexDirection:'row', display:'flex'}}>
                                    <ActivityStatus active={!item.inativo} />
                                    <Text style={{ marginTop: -3, fontSize: 12 }}>{!item.inativo? 'Ativo':'Inativo'}</Text>
                                </div>
                            </div>
                        </div>
                    </TableData>
                    <TableData width={'30%'} style={{verticalAlign: 'middle'}}>
                        <Text>{getDescricaoByCodigo(item.perfilSaude)}</Text>
                    </TableData>    
                    <TableData width={'25%'} style={{verticalAlign: 'middle'}}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <GenericSolidButton color={Colors.SPM600} onClick={navigateToCreateAgendaInner}>Criar agenda</GenericSolidButton> {/** Empresa */}
                            <TextLink style={{ marginTop: 10, marginLeft: 40, fontWeight: 'bold', color: Colors.SPM500 }} onClick={navigateToHealthProfessionalDetailInner}>{`VER AGENDAS > `}</TextLink> {/** Empresa */}
                        </div>
                    </TableData>
                </Table>)
                :(<MobileContainer>
                    <div style={{ width: '100%', marginLeft: 12 }}>
                        <RowContainer>
                            <div style={{ flexDirection: 'column', display:'flex'}}>
                                <Avatar style={{ marginTop: 10, width: 70, height: 70 }} color={Colors.SPM500} src={item.foto ? photo : avatar} /> {/** Avatar aqui caso não tenha foto */}
                                <div style={{ flexDirection:'row', display:'flex'}}>
                                    <ActivityStatus style={{ marginTop: 18 }} active={!item.inativo} />
                                    <Text style={{ fontSize: 14 }}>{!item.inativo? 'Ativo':'Inativo'}</Text>
                                </div>
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <Text>{item.nome}</Text>
                                <Text style={{ marginTop: -10 }}>{getDescricaoByCodigo(item.perfilSaude)}</Text>
                                <div style={{ flexDirection:'row', display:'flex'}}>
                                    <GenericSolidButton style={{ width: 150 }} color={Colors.SPM600} onClick={navigateToCreateAgendaInner}>Criar agenda</GenericSolidButton> {/** Empresa */}
                                    <TextLink style={{ marginTop: 10, marginLeft: 20, fontWeight: 'bold', color: Colors.SPM500 }} onClick={navigateToHealthProfessionalDetailInner}>{`VER AGENDAS > `}</TextLink> {/** Empresa */}
                                </div>
                            </div>
                        </RowContainer>

                    </div>
                </MobileContainer>)}
            </ListItemContainer>
        </>
    )
    // --------------------------------------------------------
}

export default AgendaProfissionalListItem